module.exports = __webpack_public_path__ + "img/77.6603e0fd.jpg";